import { CreateJobBodyDto, JobResponseDto, JobsService } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  workspaceId?: string;
  formItem: CreateJobBodyDto;
  persistedJobId?: string;
  setJob: (job: JobResponseDto | null) => void;
  setFormItemId: (id: string) => void;
  creationPromiseRef: { current: Promise<string | null> | null };
};

export async function ensureDraftJob({
  call,
  workspaceId,
  formItem,
  persistedJobId,
  setJob,
  setFormItemId,
  creationPromiseRef,
}: TParams): Promise<string | null> {
  if (!workspaceId || !formItem?.id) {
    return null;
  }
  if (persistedJobId) {
    return persistedJobId;
  }
  if (creationPromiseRef.current) {
    return creationPromiseRef.current;
  }

  creationPromiseRef.current = call(() =>
    JobsService.createJob({
      wsid: workspaceId,
      requestBody: {
        ...formItem,
        id: formItem.id,
        name: formItem.name?.trim() ? formItem.name : 'Unnamed',
        status: 'JOB_STATUS_DRAFT',
      },
    }),
  )
    .then((created) => {
      if (!created?.id) {
        return null;
      }
      setJob(created);
      setFormItemId(created.id);
      return created.id;
    })
    .finally(() => {
      creationPromiseRef.current = null;
    });

  return creationPromiseRef.current;
}

export const ensureDraftJobBeforeUpload = ensureDraftJob;
